// extracted by mini-css-extract-plugin
export default {"modal":"PeopleAssociation_modal__7-HEk","modalTitle":"PeopleAssociation_modalTitle__qsh22","titleSubText":"PeopleAssociation_titleSubText__ojYG4"};